import { createSelector } from '@ngrx/store';

import { AppState } from '../state';
import { MediaAssetsModel } from './media-assets.model';
import { AssetsCollection } from '@services/asset/_interfaces_/asset.mapped.interface';

export const selectMediaAssets = (state: AppState) => state.mediaAssets;

export const selectAirlineAssets = createSelector(selectMediaAssets, (state: MediaAssetsModel): AssetsCollection => state.airlines);
